var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.className},[_vm._t("before"),_c('div',{staticClass:"grid"},[_c('div',{staticClass:"l-section__content"},[_vm._t("default")],2)]),_vm._t("after")],2)}
var staticRenderFns = []

export { render, staticRenderFns }